import React from "react";
import MyTable from "../../components/Schedule/MyTable";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import { Chip } from "@mui/material";
import moment from "moment";
import ApiService from "../../functions/apiService";
import { toast } from "react-toastify";

const ManageFreePasses = (props) => {
  const { freePasses, getFreePasses } = props

  const acceptRejectReq = (row, decision) => {
    ApiService.post("/request-rfp-admin-decision", {
      "Shift_Date": row.Shift_Date,
      "Shift_Code": row.overtime_shift_list?.Shift_Code,
      "Emp_Code": row.Emp_Code,
      "decision": decision,
      "batch_number": row.overtime_shift_list?.Batch_Number,
      "list": row.overtime_shift_list?.Overtime_List,
    })
      .then((data) => {
        toast.success(data?.message)
        getFreePasses()
      })
      .catch((error) => {
        toast.error(error?.data?.message)
      });
  }

  const columns = [
    {
      field: 'date', headerName: 'Date', flex: 1, minWidth: 120, valueGetter: (params) => moment(params?.row?.Shift_Date).format('MM/DD/YYYY')
    },
    {
      field: 'shift', headerName: 'Shift', flex: 1, minWidth: 160,
      renderCell: (params) => {
        return (
          <Chip
            label={params?.row?.overtime_shift_list?.Shift_Code == 2 ? 'Day' : 'Night'}
            className={params?.row?.overtime_shift_list?.Shift_Code == 2 ? 'day-chip' : 'night-chip'}
          />
        )
      }
    },
    {
      field: 'shift_number', headerName: 'Shift Number', flex: 1, minWidth: 120, valueGetter: (params) => params?.row?.overtime_shift_list?.Shift_Number
    },
    {
      field: 'employee', headerName: 'Employee', flex: 1, minWidth: 200, valueGetter: (params) => params?.row?.requested_emp?.fullName
    },
    {
      field: 'request', headerName: 'Request', flex: 1, minWidth: 300, valueGetter: (params) => params?.row?.Value
    },
    {
      field: 'status', headerName: 'Status', flex: 1, minWidth: 160,
      renderCell: (params) => {
        return (
          <>
            {params?.row?.Status == 'DECLINED' ?
              <Chip
                style={{ textTransform: 'capitalize', backgroundColor: '#E627191A' }}
                variant="outlined" color='red'
                label={params?.row?.Status.toLowerCase()}
              />
              :
              params?.row?.Status == 'APPROVED' ?
                <Chip
                  sx={{ backgroundColor: '#01784F1A', color: '#01784F', border: '1px solid #01784F', textTransform: 'capitalize', }}
                  variant="outlined"
                  label={params?.row?.Status.toLowerCase()}
                />
                :
                <Chip
                  style={{ textTransform: 'capitalize', backgroundColor: '#FFA500', color: '#000' }}
                  label={params?.row?.Status.toLowerCase()}
                  className='requested-chip'
                />
            }
          </>
        )
      }
    },
    {
      field: 'action', headerName: 'Action', flex: 1, minWidth: 220,
      renderCell: (params) => {
        return (
          <>
            {params?.row?.Status == 'REQUESTED' &&
              <>
                <ButtonTheme
                  color="DarkGreen"
                  className="rounded-2"
                  onClick={() => { acceptRejectReq(params?.row, "approve") }}
                >
                  Accept
                </ButtonTheme>
                <ButtonTheme
                  color="red"
                  className="rounded-2 mx-2"
                  onClick={() => acceptRejectReq(params.row, "deny")}
                >
                  Reject
                </ButtonTheme>
              </>
            }
          </>
        )
      }
    },
  ]

  return (
    <>
      <MyTable
        rows={freePasses}
        columns={columns}
        checkboxSelection={false}
        hideFooter={freePasses.length > 100 ? false : true}
        rowCount={freePasses.length}
      />
    </>
  )
}

export default ManageFreePasses;